<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          İçerik
        </template>
        <b-card>
          <b-row>
            <b-col
              cols="12"
              md="12"
            >
              <lab-title />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <lab-sub-title />
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <lab-content />
            </b-col>
          </b-row>
        </b-card>
        <lab-image-card />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Galeri
        </template>
        <laboratory-photo-gallery />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BTabs, BTab, BRow, BCol,
} from 'bootstrap-vue'
import LabImageCard from '@/views/Admin/Laboratory/Elements/Image.vue'
import LabTitle from '@/views/Admin/Laboratory/Elements/TitleCard.vue'
import LabSubTitle from '@/views/Admin/Laboratory/Elements/SubTitleCard.vue'
import LabContent from '@/views/Admin/Laboratory/Elements/Content.vue'
import LaboratoryPhotoGallery from '@/views/Admin/Laboratory/Elements/PhotoGalleryCard.vue'

export default {
  name: 'LabItemForm',
  components: {
    LaboratoryPhotoGallery,
    LabContent,
    LabSubTitle,
    LabTitle,
    LabImageCard,
    BCard,
    BTabs,
    BTab,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['laboratory/dataItem']
    },
  },
}
</script>
